import { surveysSagas } from '../surveys/sagas';
import { questionnairesSagas } from '../questionnaires/sagas';

export const internalDashboardSagas = [...surveysSagas, ...questionnairesSagas];
